import palette from '../../colors/palette';

export default {
  root: {
    color: palette.icon,
    minWidth: 32
  }
};
